import React from 'react';
import {
    required,
    minLength,
    maxLength,
    minValue,
    maxValue,
    number,
    regex,
    email,
    choices,
    Create, SimpleForm, TextInput, DateInput,ReferenceInput,SelectInput,
    BooleanInput, NumberInput, ImageInput, ImageField
} from 'react-admin';
import RichTextInput from 'ra-input-rich-text';

export const CountryCreate = props => (
    <Create {...props} title="Country">
        <SimpleForm redirect="list" variant="outlined">
        <TextInput validate={required()} source="name" label="Name" fullWidth={true} />
                <TextInput validate={required()} source="code" label="Code" fullWidth={true} />
                <BooleanInput initialValue={true} source="isActive" />
        </SimpleForm>
    </Create>
);